// SWIFT code validation (ISO 9362 format)
// Format: 4 letters (bank code) + 2 letters (country code) + 2 letters/digits (location code) + optional 3 letters/digits (branch code)
// eslint-disable-next-line security/detect-unsafe-regex
export const SWIFT_REGEX = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/

// IBAN validation
// Format: 15-34 alphanumeric characters (varies by country)
export const IBAN_REGEX = /^[A-Z0-9]{15,34}$/

export const formatIbanForDisplay = (iban: string): string => {
  const cleanIban = iban.toUpperCase().replace(/[^A-Z0-9]/g, "")
  return cleanIban.replace(/(.{4})/g, "$1 ").trim()
}
